export default class ActionTracker {
    constructor() {
    }
    //loads all data over personal info/actions someone has taken on a campaign
    retrieveAllData() {
        const stringified = JSON.stringify(myObj);//take an object and turn it into a string
        const parsed = JSON.parse(stringified);//take a string and turn it into a object

        localStorage.setItem('testObject', JSON.stringify(testObject));
        // Retrieve the object from storage
        var retrievedObject = JSON.parse(localStorage.getItem('testObject'));
        return retrievedObject;
    }

    retrieveCampaignData(campaign) {
        if (localStorage.getItem(campaign) !== null) {
            var retrieved_data = JSON.parse(localStorage.getItem(campaign));
            return retrieved_data;
        }
        return null;
    }

    // call writedata when new action is completed, campaign is a str, action is a dictionary
    writeCampaignData(campaign, action){
        let localItem = localStorage.getItem(campaign);
        if (localItem == null) {
            let temp_dict = {[action.type]: {[action.name]: 1}}
            localStorage.setItem(campaign, JSON.stringify(temp_dict));
        }
        else {
            var localData = JSON.parse(localItem);
            if (!(action.type in localData)){
                localData[action.type] = {[action.name]: 1};
                localStorage.setItem(campaign, JSON.stringify(localData));
            } else if (!(action.name in localData[action.type])) {
                localData[action.type][action.name] = 1;
                localStorage.setItem(campaign, JSON.stringify(localData));
            }
        }

        //this.storeToLocalData(data);
        // this.storeToDatabase(data);
    }

    //stores data to localdata (dict)
    storeToLocalData(data){

    }

    //stores data to database
    storeToDatabase(data){

    }

    clearAllData(){
        localStorage.clear();
    }
}